<template>
    <div>
        <v-app-bar v-if="$vuetify.breakpoint.mobile" app color="background" elevation="0">
            <v-app-bar-nav-icon aria-label="Menu" @click="drawer = !drawer" />
            <v-spacer />
            <div class="d-flex align-center">
                <v-img
                    alt="Amelsy"
                    contain
                    src="/images/logo_roxo.png"
                    transition="scale-transition"
                    width="60"
                />
            </div>
            <v-spacer />
        </v-app-bar>
        <v-navigation-drawer
            v-model="drawer"
            app
            :mini-variant="!$vuetify.breakpoint.mobile"
            :expand-on-hover="!$vuetify.breakpoint.mobile"
            color="surface"
            class="rounded-r-md"
            floating
        >
            <v-list>
                <v-list-item class="px-2">
                    <v-list-item-avatar height="50">
                        <v-img alt="Amelsy" contain src="/images/logo_roxo.png" />
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title class="text-h6 font-weight-bold primary--text">Amelsy</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item class="px-2" @click="show_dialog_edit_user = true" id="tour-user-profile-btn">
                    <v-list-item-avatar size="40">
                        <v-icon v-if="!user.user_image" color="primary">mdi-account</v-icon>
                        <v-img v-else :src="user.user_image" />
                    </v-list-item-avatar>
                    <v-list-item-content class="relative">
                        <div class="absolute top-0 right-0 mt-1 mr-1">
                            <pro-status-badge v-if="user"/>
                        </div>
                        <v-list-item-title class="font-weight-medium">{{ user.name }}</v-list-item-title>
                        <v-list-item-subtitle class="text-caption">{{ user.email }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-divider class="mx-3"></v-divider>
            <v-list nav dense class="mt-2">
                <template v-for="(menu, index) in menus">
                    <v-list-item 
                        v-if="menu.isSysAdmin && isSysAdmin || !menu.isSysAdmin"
                        :key="index" 
                        link 
                        :to="isRouteBlocked(menu.link) ? undefined : menu.link"
                        @click="handleMenuClick(menu)"
                        active-class="primary--text" 
                        class="rounded-xl"
                        :id="`tour-menu-${menu.route}`"
                    >
                        <v-list-item-icon>
                            <v-icon :color="isRouteBlocked(menu.link) ? 'grey lighten-2' : ''">{{ menu.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="font-weight-medium">
                                {{ menu.name }}
                            </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action v-if="menu.isPro && !isSysAdmin && !isPro">
                            <pro-badge />
                        </v-list-item-action>
                    </v-list-item>
                </template>
            </v-list>
            <template #append>
                <div class="">
                    <v-list-item link @click="startTour" class="rounded-xl mb-2" id="tour-help-btn-menu">
                        <v-list-item-icon>
                            <v-icon color="primary">mdi-help-circle-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title class="primary--text font-weight-medium">Ajuda</v-list-item-title>
                    </v-list-item>
                    <v-list-item link @click="logout" class="rounded-xl mb-2">
                        <v-list-item-icon>
                            <v-icon color="error">mdi-logout</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title class="error--text font-weight-bold">Sair</v-list-item-title>
                    </v-list-item>
                </div>
            </template>
        </v-navigation-drawer>
        <dialog-edit-user v-model="show_dialog_edit_user" />
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import TourService from '@/services/TourService';

import DialogEditUser from '../utils/components/DialogEditUser.vue';

export default {
    components: {
        DialogEditUser
    },
    data() {
        return {
            menus: [
                {
                    name: "Agenda",
                    link: "/",
                    icon: "mdi-calendar",
                    route: "schedule"
                },
                {
                    name: "Dashboard",
                    link: "/dashboard",
                    icon: "mdi-view-dashboard",
                    route: "dashboard"
                },
                {
                    name: "Clientes",
                    link: "/customers",
                    icon: "mdi-account-group-outline",
                    route: "customers"
                },
                {
                    name: "Atendimentos",
                    link: "/sessions",
                    icon: "mdi-brain",
                    route: "sessions"
                },
                {
                    name: "Recibos",
                    link: "/vouchers",
                    icon: "mdi-file-sign",
                    route: "vouchers",
                    isPro: true
                },
                {
                    name: "Despesas programadas",
                    link: "/taxes",
                    icon: "mdi-hand-coin-outline",
                    route: "taxes",
                    isPro: true
                },
                {
                    name: "Central de notificações",
                    link: "/notifications",
                    icon: "mdi-bell-ring",
                    route: "notifications",
                    isPro: true
                },
                {
                    name: "Reagendamentos",
                    link: "/reschedule-requests",
                    icon: "mdi-calendar-refresh",
                    route: "reschedule-requests",
                    isPro: true
                },
                {
                    name: "Modelos de Contrato",
                    link: "/contract-templates",
                    icon: "mdi-file-document-edit",
                    route: "contract-templates"
                },
                {
                    name: "Usuários",
                    link: "/admin/users",
                    icon: "mdi-account-group-outline",
                    route: "users",
                    isSysAdmin: true
                }
            ],
            drawer: undefined,
            show_dialog_edit_user: false
        };
    },
    computed: {
        ...mapState("auth", {
            user: state => state.user
        }),
        ...mapGetters('auth', ['isRouteBlocked', 'isPro', 'isSysAdmin', 'profileName']),
        
        /* filteredMenus() {
            // Filtrar menus baseado no perfil
            return this.menus.filter(menu => {
                // Verificar se a rota está bloqueada usando o path
                return !this.isRouteBlocked(menu.link);
            });
        } */
    },
    created() {
        // Expose this component instance globally for tour access
        window.$sideMenu = this;
    },
    mounted() {
        this.checkTodayEvents();
        
        // Listen for tour events
        if (window.EventBus) {
            window.EventBus.$on('tour-open-user-dialog', () => {
                this.openUserDialog();
            });
        }
    },
    methods: {
        ...mapActions("auth", ["ActionDoLogout"]),
        ...mapActions("schedule", ["ActionDoGetTodayEvents"]),
        async logout() {
            await this.ActionDoLogout();
        },
        startTour() {
            const currentRoute = this.$route.name;
            TourService.startTour(currentRoute);
        },
        openUserDialog() {
            // Use $set to ensure reactivity
            this.$set(this, 'show_dialog_edit_user', true);
            console.log('[SideMenu] openUserDialog called, show_dialog_edit_user:', this.show_dialog_edit_user);
        },
        checkTodayEvents() {
            this.ActionDoGetTodayEvents();
        },
        handleMenuClick(menu) {
            // Se a rota está bloqueada, mostrar modal de upgrade
            if (this.isRouteBlocked(menu.link)) {
                if (window.EventBus) {
                    window.EventBus.$emit('show-upgrade-modal', {
                        feature: menu.name,
                        route: menu.link
                    });
                }
                // Prevenir navegação
                return false;
            }
            // Permitir navegação normal se não estiver bloqueada
        }
    }
}
</script>
